import { render, staticRenderFns } from "./DataViewSidebarComplaint.vue?vue&type=template&id=7944811e&scoped=true&"
import script from "./DataViewSidebarComplaint.vue?vue&type=script&lang=js&"
export * from "./DataViewSidebarComplaint.vue?vue&type=script&lang=js&"
import style0 from "./DataViewSidebarComplaint.vue?vue&type=style&index=0&id=7944811e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7944811e",
  null
  
)

export default component.exports